export interface Article {
  id: number;
  slug: string;
  channel: string;
  title: string;
  summary: string;
  cover: string;
  author: string;
  date: string;
  read: number;
  views: number;
  tags: string[];
  featured?: boolean;
  body: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    slug: 'taohua-shan-sheng-wei',
    channel: 'bagua',
    title: '新晋小花恋情疑曝光：同框画面流出，网友直呼般配',
    summary: '一段模糊的同框画面引爆讨论，经纪方尚未回应。吃瓜群众已从细节里扒出满满“糖点”，这场恋情瓜到底有几分真？',
    cover: 'https://readdy.ai/api/search-image?query=two%20stylish%20silhouettes%20walking%20side%20by%20side%20under%20warm%20street%20lights%20in%20a%20blossoming%20park%20at%20dusk%2C%20romantic%20soft%20focus%2C%20pink%20and%20peach%20tone%20editorial%20illustration%2C%20gentle%20and%20dreamy&width=800&height=600&seq=a01-love-rumor&orientation=landscape',
    author: '瓜田一姐',
    date: '2026-09-06',
    read: 4,
    views: 128400,
    tags: ['恋情', '新晋小花', '同框'],
    featured: true,
    body: [
      '这两天，#同款外套引发猜测#的话题悄悄爬上热搜。起因是一组被拍到的画面：镜头里两名年轻人前后脚从同一个小区走出，衣着低调却意外撞了同款配饰，敏锐的网友立刻捕捉到不寻常的气息。',
      '随后有“课代表”挖出更多线索：此前某活动现场两人曾隔空比心，社交平台上还出现过一段几乎同步的动态文案。虽没有任何实锤，但细节控们已经拼出了一套完整的“时间线”，直呼这是本月最甜的一颗瓜。',
      '截至发稿，当事双方的经纪团队均未正面回应，只留下“艺人私事不便回应”的模糊表态。公关圈人士分析，这种节奏往往是默认前的缓冲期，接下来几天恐怕还会有新的“糖点”流出。',
      '理性来看，艺人的感情生活本就属于个人选择。围观归围观，给当事人留一点空间，把更多注意力放回作品本身，或许才是更长情的“粉法”。这颗瓜后续如何发酵，我们会持续盯紧。',
    ],
  },
  {
    id: 2,
    slug: 'rebo-fen-jing-bang',
    channel: 'bagua',
    title: '本期热搜复盘：哪些瓜是真热闹，哪些瓜只是雷声大',
    summary: '一周热搜大盘点。有的瓜剧情层层反转让网友追到深夜，有的瓜热度全靠水军硬撑，我们带你逐条复盘背后的真实热度曲线。',
    cover: 'https://readdy.ai/api/search-image?query=ascending%20bar%20chart%20made%20of%20watermelon%20slices%20and%20trending%20arrows%20on%20a%20warm%20cream%20backdrop%2C%20data%20analytics%20editorial%20illustration%2C%20minimal%20and%20cheerful&width=800&height=600&seq=a02-hot-review&orientation=landscape',
    author: '理性瓜民',
    date: '2026-09-05',
    read: 5,
    views: 96000,
    tags: ['热搜', '复盘', '舆情'],
    body: [
      '每周一，热搜榜都会经历一次“大洗牌”。本期最热闹的当属某剧组主演互动的名场面，从预告到正片再到花絮，三个时段三次冲上高位，剧情自带递进感，堪称“教科书级的热度运营”。',
      '相比之下，某网红公司的“官宣即澄清”就显得有些仓促。声明发出不足三小时便被网友扒出前后口径不一，热度瞬间从“围观”转向“打假”，这种自己制造的翻车，往往比真实瓜更让人哭笑不得。',
      '还有一类“雷声大雨点小”的热搜，往往依赖短期话题词与营销号带节奏，讨论量虽高，但真正有信息量的内容寥寥。评论区一片空转，热度来得快去得也快，属于典型的“脱水后”现原形。',
      '给吃瓜群众一个建议：判断一颗瓜值不值得追，别只看话题词冲得多高，更要看有没有“实锤”与后续。真正的好瓜，通常都不需要水军熬夜加班。',
    ],
  },
  {
    id: 3,
    slug: 'hongtan-mianxing-hui',
    channel: 'mingxing',
    title: '年度红毯盘点：谁的造型让人眼前一亮，谁又被造型师坑了',
    summary: '红毯是明星审美的战场，也是造型师口碑的检验场。盘点本届红毯的惊艳瞬间与翻车造型，顺便聊聊镜头前后那些不为人知的小细节。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20long%20evening%20gown%20train%20sweeping%20across%20a%20glimmering%20red%20carpet%20at%20night%2C%20golden%20bokeh%20photographers%20flashes%2C%20luxury%20fashion%20editorial%20photography%20with%20warm%20glamorous%20lighting&width=800&height=600&seq=a03-red-carpet&orientation=landscape',
    author: '时尚观察员',
    date: '2026-09-04',
    read: 6,
    views: 153000,
    tags: ['红毯', '造型', '时尚'],
    body: [
      '红毯从来不只是走两步那么简单的“show time”。对艺人而言，它是一次公开的审美考核；对造型团队而言，则是几个月筹备的一次性答卷。本届红毯上，率先“封神”的是一位不走寻常路的女演员——她把东方水墨的留白感穿上了身，在清一色的高定大裙摆里杀出重围。',
      '而翻车案例同样不缺。某艺人顶着“前卫先锋”的标签登场，层层叠叠的设计却让本人显得矮了一截，评论区立刻出现“把礼服还给模特”的调侃。造型师与艺人之间若没有足够的沟通默契，风格就很容易变成“事故现场”。',
      '值得关注的是，越来越多新生代开始尝试“国风”与高定的融合，盘扣、刺绣、剪影被解构成更当代的表达。这种有文化底色的造型，往往比盲目追逐国际大牌更让人记得住。',
      '说到底，红毯造型的成功与否，标准始终只有一条——是否放大了艺人本身的特质。衣服是为人服务的，而不是反过来。期待下一场红毯，能有更多“人穿衣”的高级时刻。',
    ],
  },
  {
    id: 4,
    slug: 'xiaoguo-jiating-fenlu',
    channel: 'mingxing',
    title: '顶流居家综艺开播：镜头下的“真实”，究竟几分真',
    summary: '纪实类居家综艺渐成流量新宠。有人说看到了明星卸下包袱的一面，也有人质疑剧本痕迹太重。真实与演绎之间的边界在哪里？',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20sunlit%20living%20room%20with%20a%20large%20tv%20playing%20a%20warm%20reality%20show%2C%20cups%20of%20tea%20and%20snacks%20on%20coffee%20table%2C%20homely%20lifestyle%20editorial%20illustration%2C%20soft%20natural%20morning%20light&width=800&height=600&seq=a04-reality-show&orientation=landscape',
    author: '追综狂魔',
    date: '2026-09-03',
    read: 5,
    views: 89000,
    tags: ['综艺', '真人秀', '顶流'],
    body: [
      '一档号称“没有剧本”的顶流居家综艺，刚开播两期就冲上了收视第一。镜头里的艺人晨起做早餐、为宠物梳毛、和朋友视频连线，松弛感拉满，粉丝们直呼“看到了偶像生活化的一面”。',
      '然而，追了两期的老观众很快发现了端倪：连麦的“好友”恰好都是同档期有作品宣传的艺人，做早餐的镜头总有恰到好处的品牌特写，甚至连聊天的梗都能对上热搜的时间点。所谓“真实”，正在被精心包装。',
      '纪实类节目之所以受欢迎，本质是观众渴望“去滤镜”的亲密感。但当真实的代价是每个镜头都要排布，这份亲密感便打了折扣。业内坦言，真人秀的“真”从来都是相对的，观众看的其实是“真实感”的艺术。',
      '与其纠结谁真谁假，不如把它当成一部生活化的轻综艺来看。能给繁忙日常提供一点解压和快乐，这档节目就已完成了它的本分。至于镜头背后的深水区，留给“显微镜追星”的观众继续探索吧。',
    ],
  },
  {
    id: 5,
    slug: 'wanzhu-xingren-jiechu',
    channel: 'wanghong',
    title: '涨粉百万的“人设”崩塌全过程：一条旧视频引发的连锁反应',
    summary: '凭借暖心人设爆火的男主播，因一条三年前的旧视频被考古，人设瞬间反转。这场从顶流到塌房的七十二小时，到底发生了什么？',
    cover: 'https://readdy.ai/api/search-image?query=broken%20glass%20fragments%20forming%20a%20cracked%20silhouette%20of%20a%20person%20on%20a%20warm%20amber%20background%2C%20dramatic%20lighting%2C%20conceptual%20editorial%20illustration%20about%20image%20collapse&width=800&height=600&seq=a05-persona-crash&orientation=landscape',
    author: '显微镜网友',
    date: '2026-09-02',
    read: 7,
    views: 210000,
    tags: ['人设崩塌', '考古', '翻车'],
    featured: true,
    body: [
      '本周最“惊悚”的瓜，属于一位靠暖心治愈视频涨粉百万的男主播。他的视频常年在深夜上线，配着温柔的旁白安抚焦虑的年轻人，评论区一度是全网最友善的地方之一，人称“情绪避风港”。',
      '转折来得毫无预兆。一位网友“考古”到他三年前在某平台发布的旧视频，画面里他正用轻蔑的口吻嘲讽另一类内容创作者。随后，更多旧物料被接连挖出——早期视频里的刻薄评论、营销号带节奏的合作截图、甚至被指“搬运”他人创意却从未署名。',
      '短短七十二小时，风向急转直下。从“人间温柔”到“塌房预订”，平台账号一夜掉粉数十万，过往合作品牌陆续撤下宣传物料。面对汹涌的质疑，他发布了一封时长仅四十秒的道歉视频，被网友评价为“教科书级的避重就轻”。',
      '这场反转给内容行业留下深刻警醒：屏幕前的“人设”，终究要靠屏幕后的真实去托底。人设可以包装，但经不起考古；真诚也许慢，却最经得起时间。一个人设的崩塌往往不是瞬间的事，而是过去所有细节的“攒局”。',
    ],
  },
  {
    id: 6,
    slug: 'zhibo-shengyi-kao',
    channel: 'wanghong',
    title: '直播带货翻车实录：当“家人们”发现价格并不香',
    summary: '“全网最低价”成了直播间高频词，可货比三家后，越来越多消费者发现直播间价格并不占优。这颗价格瓜，该由谁来买单？',
    cover: 'https://readdy.ai/api/search-image?query=live%20shopping%20cart%20and%20loudspeaker%20with%20floating%20price%20tags%20being%20crossed%20out%2C%20money%20scale%20balancing%2C%20warm%20minimal%20ecommerce%20editorial%20illustration%2C%20clear%20and%20cheerful&width=800&height=600&seq=a06-live-shopping&orientation=landscape',
    author: '理性吃瓜',
    date: '2026-09-01',
    read: 6,
    views: 76000,
    tags: ['直播带货', '价格', '消费者'],
    body: [
      '"家人们，今天这个价真的亏本了，就这一次机会！"这句话几乎是每场直播的固定开场。但最近一位测评博主做了个对照实验：把直播间声称的“历史最低价”，与电商平台同款商品的历史价格曲线一一比对，结果发现，相当一部分商品的直播间价并不比日常大促便宜，甚至偶尔更高。',
      '测评一出，瞬间引爆讨论。不少在直播间“激情下单”的消费者直呼被“家人们”三个字绑架了钱包。而主播团队则回应称，价格受品牌控价、补贴机制等多重因素影响，不能简单横向对比。',
      '事实上，直播间的价格体系远比表面上复杂：有的“低价”来自品牌补贴，有的则通过更换规格、压缩赠品来实现。消费者真正需要的，不是一句冲动的“买它”，而是清晰透明的比价信息。',
      '作为围观者，我们更希望看到的是：直播电商在跑过野蛮生长期后，能逐渐回到“好货好价好服务”的本源。价格可以卷，但别卷掉诚信；销量可以冲，但别冲散信任。',
    ],
  },
  {
    id: 7,
    slug: 'yuanchuang-ju-huo',
    channel: 'yingshi',
    title: '这部原创剧本杀式悬疑剧，凭什么口碑炸裂',
    summary: '没有大IP加持、没有顶流主演，一部原创悬疑剧却靠层层反转圈粉无数。它到底做对了什么，让观众心甘情愿追到凌晨？',
    cover: 'https://readdy.ai/api/search-image?query=dark%20moody%20detective%20room%20with%20pinned%20case%20files%20and%20red%20string%20connecting%20clues%2C%20single%20desk%20lamp%20glow%2C%20cinematic%20mystery%20film%20set%20photography%2C%20tense%20and%20atmospheric&width=800&height=600&seq=a07-suspense-drama&orientation=landscape',
    author: '追剧课代表',
    date: '2026-08-30',
    read: 8,
    views: 175000,
    tags: ['悬疑剧', '原创', '口碑'],
    featured: true,
    body: [
      '在改编剧扎堆、大IP横行的当下，一部纯原创的悬疑剧《局中局》成了本季最大黑马。首播三日豆瓣开分便冲到高位，社交平台上一片“烧脑预警”，甚至出现剧粉连夜整理人物关系图谱的盛况。',
      '这部剧最聪明的地方，是把“剧本杀”的逻辑揉进了叙事：观众和主角共享同一份信息，每个看似多余的镜头，都可能在后几集变成关键伏笔。当谜底揭晓的那一刻，许多人回头二刷，才发现编剧早已在台词里埋下了答案。',
      '比起流量堆砌，它更像一场给观众的“智力尊重”。导演在采访中坦言，团队反复打磨了两年剧本，宁可删掉讨喜的工具人角色，也要保证每一条人物线都有动机闭环。这份较真，观众是能感受到的。',
      '当然，它也并非没有争议：中期节奏偏慢、部分反转依赖巧合，被部分观众诟病。但瑕不掩瑜，它证明了在浮躁的市场里，“好好讲故事”依然是最被市场买账的王牌。这样的原创作品，请再多来几部。',
    ],
  },
  {
    id: 8,
    slug: 'zongyi-jianji-xia',
    channel: 'yingshi',
    title: '剪辑“剪刀手”争议：同一个人物，为什么看起来如此不同',
    summary: '同一档综艺，被不同平台的剪辑呈现出截然相反的人设。当“恶意剪辑”成为高频词，真人秀到底还能不能信？',
    cover: 'https://readdy.ai/api/search-image?query=two%20scissors%20cutting%20a%20film%20strip%20with%20contrasting%20happy%20and%20tense%20faces%20split%20in%20half%2C%20conceptual%20media%20editing%20illustration%2C%20warm%20and%20cool%20duotone%20on%20cream%20background&width=800&height=600&seq=a08-editing-controversy&orientation=landscape',
    author: '老观众',
    date: '2026-08-28',
    read: 5,
    views: 63000,
    tags: ['综艺', '剪辑', '争议'],
    body: [
      '一档观察类综艺最近陷入了“剪辑争议”的漩涡。起因是某嘉宾在正片里被呈现得急躁强势、频频打断别人，遭遇铺天盖地的负面评论；可当粉丝放出会员加长版后，网友们却发现，同样是这段对话，因为多了一句上下文，整个观感完全反转。',
      '一时间，“恶意剪辑”成了热搜常客。事实上，综艺剪辑是一门“叙事的手艺”，素材量动辄上百小时，剪辑师必须在有限时长里做取舍。取舍本身无可厚非，但当“冲突”被当作流量密码，剪辑便容易从“还原现场”滑向“制造人设”。',
      '争议的根源，其实是信息的不对等。观众看到的是精心挑选的片段，嘉宾所处的完整语境却无从知晓。被断章取义的嘉宾成了话题的牺牲品，而节目组则靠“争议+澄清”的两波热搜坐收流量。',
      '对此，观众能做的或许只有一件事——在看到争议片段时，先别急着站队。多看两版，多等等后续，让子弹飞一会儿。真相也许会迟到，但完整的素材总比掐头去尾的镜头更接近真实。',
    ],
  },
  {
    id: 9,
    slug: 'qingnian-yeyin-hua',
    channel: 'shehui',
    title: '年轻人流行“电子榨菜”：下饭看什么，反映我们怎么活',
    summary: '从追剧到听播客，年轻人把“电子榨菜”吃出了花。在快节奏生活里，这种陪伴式的内容消费，究竟慰藉了什么？',
    cover: 'https://readdy.ai/api/search-image?query=young%20person%20eating%20a%20bowl%20of%20rice%20while%20watching%20content%20on%20a%20tablet%2C%20cozy%20flat%20illustration%20with%20snack%20icons%20floating%2C%20warm%20soft%20colors%2C%20relatable%20and%20lively&width=800&height=600&seq=a09-digital-pickles&orientation=landscape',
    author: '人间观察笔记',
    date: '2026-08-26',
    read: 6,
    views: 58000,
    tags: ['电子榨菜', '年轻人', '生活'],
    featured: true,
    body: [
      '不知道从什么时候起，一个人吃饭成了很多年轻人的日常。而饭桌对面最忠实的“饭友”，往往不是某个人，而是一块屏幕——有人下饭必配情景喜剧，有人只听播客，还有人习惯循环一部看过无数遍的老番。大家给这类内容起了个接地气的名字：“电子榨菜”。',
      '有心理学家指出，电子榨菜的功能远不止“解闷”。独自用餐时的孤独感，会被熟悉的声音和画面有效稀释；固定的内容节奏，也给高强度的生活提供了一个“低耗能的缓冲带”。它其实是一种温柔的自我照顾。',
      '有趣的是，不同人偏好的“榨菜口味”，也折射出各自的生活状态：爱看悬疑烧脑的人往往主动、爱思考；喜欢温馨治愈向的人，或许正在经历需要被抚慰的阶段。内容口味，成了当下情绪的隐形晴雨表。',
      '当然也有声音提醒：电子榨菜虽香，别让它完全取代了真实的交流。偶尔关掉屏幕，约朋友面对面吃顿饭，让“饭搭子”从虚拟回到现实，那种热气腾腾的陪伴，是任何流媒体都无法替代的。',
    ],
  },
  {
    id: 10,
    slug: 'wangluo-yan-guanli',
    channel: 'shehui',
    title: '“已读不回”焦虑：网络社交的边界感，正在被重新定义',
    summary: '消息“已读不回”竟能引发一场情绪海啸。从秒回到失踪，当代人的社交边界感，正在一场场小误会里被重新划分。',
    cover: 'https://readdy.ai/api/search-image?query=two%20smartphones%20with%20read%20receipts%20and%20a%20pause%20symbol%20between%20them%20on%20a%20soft%20terracotta%20background%2C%20conceptual%20social%20media%20boundary%20illustration%2C%20minimal%20and%20thoughtful&width=800&height=600&seq=a10-read-receipt&orientation=landscape',
    author: '社交观察员',
    date: '2026-08-24',
    read: 4,
    views: 43000,
    tags: ['社交', '已读不回', '情绪'],
    body: [
      '“消息明明已读，三个小时都没回我，是不是我哪里惹到他了？”这样的内心戏，几乎每个聊过天的人都经历过。最近，#已读不回算不算冷暴力#的讨论冲上热搜，评论区瞬间变成大型“情绪展销会”。',
      '有人委屈：发出去的长消息石沉大海，对方却在朋友圈岁月静好，感觉自己被“选择性忽略”。也有人委屈：工作一天累到不想说话，消息先放着，等缓过来再回却总觉得隔了太久，干脆拖着。',
      '社交软件把“在线”与“已读”变成了透明状态，本意是提高沟通效率，却也悄悄剥夺了人们“暂不回应”的自由。当回复速度被默认为关系的标尺，成年人连喘口气的时间，都要担心背上“态度问题”的罪名。',
      '说到底，消息已读未回，未必等于关系的崩塌，也可能只是对方也需要一点“数字生活”里的边界感。与其陷入无限脑补，不如坦诚沟通、合理期待。让沟通回到内容本身，而不是被“秒回”的规则绑架——这或许才是当代社交最该修的课题。',
    ],
  },
  {
    id: 11,
    slug: 'jiemu-gupiao-baoguang',
    channel: 'wanghong',
    title: '平台限流背后的生态之争：中小创作者正在经历什么',
    summary: '算法偏爱头部，流量向大主播集中，中小创作者坦言“越做越累”。平台生态的天平，还能不能向普通人倾斜一点？',
    cover: 'https://readdy.ai/api/search-image?query=tiny%20content%20creator%20standing%20on%20a%20stack%20of%20books%20reaching%20for%20a%20giant%20glowing%20spotlight%20in%20a%20vast%20sky%2C%20ambition%20and%20challenge%20illustration%2C%20warm%20golden%20hour%20tones&width=800&height=600&seq=a11-algorithm-ecology&orientation=landscape',
    author: '幕后观察',
    date: '2026-08-22',
    read: 7,
    views: 52000,
    tags: ['限流', '算法', '创作者'],
    body: [
      '一位做了三年美食视频的博主，最近在长文里自嘲“把爱好做成了焦虑”。他坦言，随着平台对头部直播间的流量倾斜，自己精心拍摄的视频播放量肉眼可见地下滑，而同期的引流直播却越来越依赖投流预算。“不是内容不好，是发出去就沉底。”这句话说出了无数中小创作者的心声。',
      '平台并非不努力。近两年，各大内容平台陆续推出扶持计划，从流量补贴到创作激励，试图为“腰部”和“长尾”创作者打开空间。但在“强者通吃”的推荐机制下，扶持的力度往往被算法分配的效率抵消，新人想出头的门槛依然不低。',
      '更深层的问题在于，内容生态的健康度不只取决于头部多么光鲜，更取决于底部有多少人能坚持。当普通人发现努力难以被看见，创作者的供给端就会萎缩，最终影响的将是整个平台的内容多样性。',
      '对平台而言，如何平衡“商业效率”与“生态公平”，是一道长期考题。而对仍在坚持的中小创作者来说，与其追逐随时变动的算法，不如守住差异化的内容护城河。流量或许会偏爱一时的热闹，但真正的价值，总会被时间慢慢打捞。',
    ],
  },
  {
    id: 12,
    slug: 'weilai-guanxian-dongtai',
    channel: 'mingxing',
    title: '从舞台到幕后：那些“跨界转型”的艺人，后来都怎样了',
    summary: '有人转型做制片越做越稳，有人跨行开店折戟沉沙。盘点艺人转型的得与失，看“流量退潮”之后，职业艺人如何找到第二曲线。',
    cover: 'https://readdy.ai/api/search-image?query=person%20stepping%20from%20a%20bright%20stage%20spotlight%20toward%20a%20subtle%20film%20clapperboard%20and%20rising%20career%20graph%2C%20sunrise%20over%20horizon%2C%20transition%20and%20growth%20illustration%2C%20warm%20hopeful%20tones&width=800&height=600&seq=a12-transition&orientation=landscape',
    author: '行业速写',
    date: '2026-08-20',
    read: 6,
    views: 71000,
    tags: ['艺人转型', '幕后', '第二曲线'],
    body: [
      '当“流量红利见顶”成为行业共识，越来越多艺人开始认真思考：如果不靠热搜吃饭，我还能靠什么立足？于是，“跨界转型”从一个宣传话术，变成了一场真实的职业迁徙。',
      '转型的路径五花八门。有人退居幕后转型制片人，把台前积累的人脉与审美变成项目的生产力，出品节奏稳扎稳打，成为圈内靠谱的代名词；有人考取专业院校进修导演，用一部部低成本作品打磨手艺；也有人投身餐饮与美妆，把个人IP变现为实体生意——这条路的风险同样显而易见。',
      '翻开转型成功者的共性，往往不是“什么都试”，而是“有取舍地深耕”。他们把公众人物的曝光度，转化为进入新领域的入场券，却仍以敬畏之心对待新职业本身。反观一些急于变现的跨界，多为追逐风口的一时冲动，热度退去后便留下一地鸡毛。',
      '对行业而言，艺人的多元化并非坏事，它意味着娱乐产业正在告别对单一流量的依赖，走向更成熟的职业化。对观众而言，我们也乐见更多人放下“完美偶像”的包袱，脚踏实地找到属于自己的长久事业。毕竟，没有谁的职业生涯，只靠热搜活着。',
    ],
  },
];

export function getArticle(id: number): Article | undefined {
  return articles.find((a) => a.id === Number(id));
}

export function getArticlesByChannel(slug: string): Article[] {
  return articles.filter((a) => a.channel === slug);
}